// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YZCO","questions":"styles_questions__3HtJr","footer":"styles_footer__1XW14"};